import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFilter } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";

const baseUrl = "/api/sif/drob/ppsElement";

export const getPpsElementTypes = createAsyncThunk(
  "ppsElement/getAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        { page: 0, size: 1000 },
        new ApiFilter().or((orGroup) => {
          orGroup.where("veljaZaKoze", "EQ", true);
          orGroup.where("veljaZaOvce", "EQ", true);
        })
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const ppsElementSlice = createSlice({
  name: "ppsElements",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPpsElementTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPpsElementTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.content || [];
      })
      .addCase(getPpsElementTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default ppsElementSlice.reducer;
